import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Check02 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="check-02">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.2809 6.37528C17.6259 6.80654 17.556 7.43583 17.1247 7.78084C15.9775 8.69863 14.809 10.2489 13.7867 11.8929C12.7768 13.5171 11.9618 15.1469 11.5037 16.1464C11.3491 16.4837 11.0204 16.7077 10.6499 16.7282C10.2794 16.7487 9.92802 16.5624 9.73711 16.2442C9.40906 15.6975 8.80589 14.9689 8.13839 14.2701C7.47322 13.5738 6.81395 12.9795 6.41184 12.6871C5.96519 12.3623 5.86644 11.7368 6.19127 11.2902C6.51611 10.8435 7.14153 10.7448 7.58818 11.0696C8.12752 11.4619 8.8804 12.1514 9.58461 12.8886C9.86455 13.1817 10.1479 13.4939 10.4155 13.81C10.8711 12.918 11.4406 11.8784 12.0883 10.8368C13.1415 9.14296 14.455 7.35538 15.8753 6.21911C16.3066 5.8741 16.9359 5.94402 17.2809 6.37528Z"
                />
            </g>
        </SvgIcon>
    );
};
